import type { TElement } from "@editor/modules/media-lib/types";
import type { TMetadata } from "@editor/modules/static/@library/types";
import { nanoid } from "@reduxjs/toolkit";
import type { IMediaFile } from "@/shared/types";

interface IProps {
  type: string;
  viewType?: "inline" | "preview";
  src: string;
  metadata?: TMetadata;
  alt?: string;

  shouldUpload?: boolean;

  width?: number;
  height?: number;
}

export const makeVideosPanelVideoElement = ({
  metadata,
  src,
  type,
  viewType = "inline",
  alt = "",
  width,
  height,
  shouldUpload = true,
}: IProps): TElement => ({
  category: "Video",
  element: "Video",
  id: nanoid(),
  json: {
    id: nanoid(),
    children: [],
    type: "element",
    settings: {
      metaImage: "",
      metaDescription: "",
      metaTitle: "",
      metaIcon: "",
      metaSiteName: "",
      metaDomain: "",
      ariaLabel: alt,
      ...metadata,
      src: appendUploadParam(src, shouldUpload),
      type: type,
      shadow: "none",
      round: "8px",
      width: "75",
      code: "",
      controls: true,
      loop: true,
      autoplay: true,
      horizontalAlignment: "center",
      shape: "16-9",
      dynamicVariableSrc: null,
      name: "Video",
      view: viewType,
      metadata: {
        width: width,
        height: height,
      },
    },
  },
  order: 0,
  previewImage: null,
});

interface IVideoFromFileProps {
  mediaFile: IMediaFile;
  shouldUpload?: boolean;
  alt?: string;
}

export const makeVideoElementFromMediaFile = ({
  mediaFile,
  shouldUpload = false,
  alt,
}: IVideoFromFileProps) => {
  return makeVideosPanelVideoElement({
    src: mediaFile.url,
    type: "Library",
    width: mediaFile.metadata?.width,
    height: mediaFile.metadata?.height,
    shouldUpload: shouldUpload,
    alt,
  });
};

function appendUploadParam(url: string, shouldUpload: boolean) {
  if (!shouldUpload) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}upload=true`;
}
